const { isUndefined } = require('lodash');
const getRootOuterBBox = require('../getRootOuterBBox');

const ensureNumbers = (arr) => arr.filter((item) => !isUndefined(item));

/**
 * Returns the minimal view box - BBox of a given roots array.
 * @param {Root[]} roots - The roots to create bbox to
 * @param {Number} gutters - Creates a view box gutters, instead of using inner padding as pixels
 * @returns {String}
 */
const getRootsBBox = (roots, gutters = 0) => {
    const rootsPositions = roots.map(getRootOuterBBox);

    const { minLeft, minTop, maxHeight, maxWidth } = rootsPositions.reduce((acc, rootPosition) => {
        const { minTop, minLeft, maxHeight, maxWidth } = acc;

        const { top, left, height, width } = rootPosition;

        // Preventing from "invisible" roots to disturb calculations
        if (width === 0 || height === 0) { return acc; }

        return {
            minTop: Math.min(...ensureNumbers([minTop, top])),
            minLeft: Math.min(...ensureNumbers([minLeft, left])),
            maxHeight: Math.max(...ensureNumbers([maxHeight, top + height])),
            maxWidth: Math.max(...ensureNumbers([maxWidth, left + width]))
        };
    }, {});

    return [
        minLeft - gutters / 2,
        minTop - gutters / 2,
        maxWidth - minLeft + gutters,
        maxHeight - minTop + gutters
    ].join(' ');
};

module.exports = getRootsBBox;
